<template>
  <div class="home">
    <a-header 
      title="Help protect yourself and your family."
      body="Your employer has partnered with Assurity to offer these valuable voluntary benefits!"
      :image="require('@/assets/images/home-banner.png')"
    >
    <template slot="cta">
      <form @submit="submitProposalId($event)" class="proposal-id__form">
        <label for="benefit-code" class="proposal-id__label">Benefit Code</label>
        <input type="text" placeholder="Benefits Code" id="benefit-code" v-model="proposalID" class="proposal-id__input" />
        <button class="proposal-id__submit">Submit</button>
      </form>
    </template>
    </a-header>
    <div class="section-header">
      <a-dotted-line />
    </div>
  </div>
</template>

<script>
import AHeader from '@/components/a-header'
import ADottedLine from '@/components/a-dotted-line'
export default {
  name: 'Home',
  components: {
    AHeader,
    ADottedLine
  },
  data() {
    return {
    }
  },
  computed: {
    proposalID: {
      get() {
        return this.$store.state.ProposalId;
      },
      set(value) {
        this.$store.commit("setProposalId", value);
      }
    }
  },
  methods: {
    submitProposalId($event) {
      if ($event) $event.preventDefault();
      this.$router.push(`/${this.proposalID}`);
    }
  },
  mounted() {
    const proposalID = localStorage.getItem('proposalId'); 
    if(proposalID) {
      this.proposalID = proposalID;
      this.submitProposalId();
    }
  }
}
</script>
<style lang="scss" scoped>
.proposal-id {
  &__form {
    text-align: center;
    margin: 0 0 $spacing-md;
    @include tablet-portrait {
      margin: 0 0 $spacing-lg;
    }
  }
  &__label {
    display: block;
    font-size: 12px;
    color: $secondary;
    visibility: hidden;
    font-weight: bold;
    margin: 0 0 $spacing-sm;
  }
  &__input {
    border: 1px solid $lightgray;
    padding: 10px 15px;
    font-size: 1.125rem;
    color: $gray;
  }
  &__submit {
    padding: 11px $spacing-md;
    background: $primary;
    font-size: 1.125rem;
    border: none;
    color: $white;
  }
}

.section-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
}
.section-header__sub {
  font-size: 1.2em;
  font-style: italic;
  color: $gray;
}
.section-header__main {
  font-size: 2.5em;
  font-weight: bold;
  color: $red;
}
.section {
  margin: 50px;
}
</style>
